module.exports = __webpack_public_path__ + "static/img/Watches1.22f8fd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Watches1.jpg
// module id = +WNn
// module chunks = 1